@if (videoArray) {
  @for (video of videoArray; track video; let i = $index) {
    <div class="video__entity" [class.video__entity--responsive]="responsive">
      @if (embeddedInputs && embeddedInputs.length && embeddedInputs[i]) {
        <div class="video-container" [innerHtml]="embeddedInputs[i]"></div>
      }
      @if (embedFailed && video.videoId) {
        <div class="video-container">
          @if (video.finalUrl) {
            <iframe attr.aria-label="{{ 'generic.youtube_video' | translate }}" title="{{ 'generic.youtube_video' | translate }}"
            [src]="video.finalUrl" allowfullscreen (load)="onLoad.emit()" [tabindex]="untabbable ? -1 : undefined" [attr.aria-hidden]="untabbable"></iframe>
          }
        </div>
      }
      @if (video.videoDescription && embedFailed) {
        <div class="video-alt-text">{{video.videoDescription}}</div>
      }
      @if (video.videoDescription && embeddedInputs.length && embeddedInputs[i]) {
        <div class="video-alt-text">{{video.videoDescription}}</div>
      }
    </div>
    }<!--/video__entity-->
  }
